export function getValuesHash(values: (string | number | boolean)[]): string {
  const str = values.map(String).join('|');

  let hash = 0;
  for (const char of str) {
    hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  }

  return hash.toString(36);
}
